import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTooltip } from '../Tooltip/Tooltip';
import { useLinesContext } from '../../../contexts/Lines';
import { lineStatus } from '../../../utils/enums';
import Checkbox from '@material-ui/core/Checkbox';
import cloneDeep from 'lodash.clonedeep';

const useStyles = makeStyles((theme: any) => ({
  checkboxCell: {
    padding: 0,
    marginRight: 13,
    marginLeft: -theme.spacing(0.5),
    '& .Mui-checked': {
      color: theme.palette.primary.dark,
    },
  },
  checkbox: { padding: 0 },
  checkboxActive: {
    '& .MuiCheckbox-colorPrimary': {
      color: theme.palette.brand.greenDark,
    },
  },
}));

export default function LineCheckboxCell({ line }) {
  const classes = useStyles({ editing: line?.edit });
  const { lines, setLines } = useLinesContext();
  const isLineEditable = line.status === lineStatus.draft;

  function handleLineSelected(lineId: string) {
    let updatedLines = cloneDeep(lines);
    updatedLines?.forEach((l) => {
      if (l.id === lineId) l.checked = !l.checked;
    });
    setLines(updatedLines);
  }

  return (
    <div
      className={
        classes.checkboxCell + ' ' + (isLineEditable && classes.checkboxActive)
      }
    >
      <>
        {isLineEditable && (
          <Checkbox
            className={classes.checkbox}
            color="primary"
            checked={line?.checked ? true : false}
            disabled={line?.new || line?.edit ? true : false}
            onClick={() => {
              handleLineSelected(line.id);
            }}
            size="small"
          />
        )}
        {!isLineEditable && (
          <CustomTooltip
            arrow
            title="Can only edit draft lines"
            placement="top"
          >
            <div>
              <Checkbox
                disabled={true}
                className={classes.checkbox}
                size="small"
              />
            </div>
          </CustomTooltip>
        )}
      </>
    </div>
  );
}
